/* eslint-disable consistent-return */
import { loaderService } from 'src/services/loaderService';
import { apileads } from '../enviroment/apileads';

const getCampana = async () => {
  loaderService.show();
  const response = await apileads.get('/v1/campanas');
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.log('Error get List ');
  }
};



const postCampana = async (params) => {
  loaderService.show();
  const response = await apileads.post('/v1/campanas', params);
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.error(error, 'Error al Postear');
  }
};

const putCampana = async (params) => {
  loaderService.show();
  const response = await apileads.put('/v1/campanas', params);
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.error(error, 'Error al Actualizar');
  }
};

const deleteCampana = async (id) => {
  loaderService.show();
  const response = await apileads.delete(`/v1/campanas?id=${id}`);
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.erro(error, 'Error al Eliminar');
  }
  
};

const getCampanaBy = async (params) => {
  const body = {
    data: params,
  }
  console.log(body, 'body')
  loaderService.show();
  const response = await apileads.post('/v1/campanas/ciudad', body);
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.log('Error get List ');
  }

};

export {
  getCampana, postCampana, putCampana, deleteCampana, getCampanaBy
};
